import { STAKING_REWARD_STATE } from '../common/name-space';

export const rewardStateFilter = (aData: number): string => {
  let re = null;
  switch (aData) {
    case STAKING_REWARD_STATE.WAITING:
      re = '대기';
      break;
    case STAKING_REWARD_STATE.ING:
      re = '진행중';
      break;
    case STAKING_REWARD_STATE.END_SUCCESS:
      re = '종료(성공)';
      break;
    case STAKING_REWARD_STATE.END_FAIL:
      re = '종료(실패)';
      break;
    default:
      re = '에러';
      break;
  }
  return re;
};
